import React, { useContext, useEffect, useState } from 'react';
import { DataContext } from '../contexts/DataContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faCalculator } from '@fortawesome/free-solid-svg-icons';

const PaymentAdvanceExpensesSummaryCard = () => {
  const { paymentAdvances } = useContext(DataContext);
  const [totalTaxExpenses, setTotalTaxExpenses] = useState(0);
  const [totalActualExpenses, setTotalActualExpenses] = useState(0);
  const [totalCustomBrokerageExpenses, setTotalCustomBrokerageExpenses] = useState(0);
  const [averageTax, setAverageTax] = useState(0);
  const [averageActual, setAverageActual] = useState(0);
  const [averageCustomBrokerage, setAverageCustomBrokerage] = useState(0);

  useEffect(() => {
    const taxExpenses = paymentAdvances.flatMap(advance => advance.tax_expenses.map(exp => exp.amount));
    const actualExpenses = paymentAdvances.flatMap(advance => advance.actual_expenses.map(exp => exp.amount));
    const customBrokerageExpenses = paymentAdvances.flatMap(advance => advance.custom_brokerage_expenses.map(exp => exp.amount));

    const totalTax = taxExpenses.reduce((acc, curr) => acc + curr, 0);
    const totalActual = actualExpenses.reduce((acc, curr) => acc + curr, 0);
    const totalCustomBrokerage = customBrokerageExpenses.reduce((acc, curr) => acc + curr, 0);

    setTotalTaxExpenses(totalTax);
    setTotalActualExpenses(totalActual);
    setTotalCustomBrokerageExpenses(totalCustomBrokerage);

    // Calculate averages
    setAverageTax(taxExpenses.length > 0 ? totalTax / taxExpenses.length : 0);
    setAverageActual(actualExpenses.length > 0 ? totalActual / actualExpenses.length : 0);
    setAverageCustomBrokerage(customBrokerageExpenses.length > 0 ? totalCustomBrokerage / customBrokerageExpenses.length : 0);
  }, [paymentAdvances]);

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg">
      <h2 className="text-xl font-bold text-gray-800 flex items-center mb-4">
        <FontAwesomeIcon icon={faDollarSign} className="text-blue-600 mr-3" />
        Expenses Summary
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-center">
        {/* Tax Expenses */}
        <div>
          <p className="text-md font-semibold text-gray-600">Tax Expenses</p>
          <p className="text-lg text-gray-800">${totalTaxExpenses.toFixed(2)}</p>
          <p className="text-sm text-gray-500">Avg: ${averageTax.toFixed(2)}</p>
        </div>

        {/* Actual Expenses */}
        <div>
          <p className="text-md font-semibold text-gray-600">Actual Expenses</p>
          <p className="text-lg text-gray-800">${totalActualExpenses.toFixed(2)}</p>
          <p className="text-sm text-gray-500">Avg: ${averageActual.toFixed(2)}</p>
        </div>

        {/* Custom Brokerage Expenses */}
        <div>
          <p className="text-md font-semibold text-gray-600">Custom Brokerage</p>
          <p className="text-lg text-gray-800">${totalCustomBrokerageExpenses.toFixed(2)}</p>
          <p className="text-sm text-gray-500">Avg: ${averageCustomBrokerage.toFixed(2)}</p>
        </div>
      </div>
      <div className="mt-4 text-center">
        <FontAwesomeIcon icon={faCalculator} className="text-green-600 mr-2" />
        <span className="text-md text-gray-600">Averages calculated across all payment advances</span>
      </div>
    </div>
  );
};

export default PaymentAdvanceExpensesSummaryCard;
